module.exports = __webpack_public_path__ + "static/media/Group 1702.6224b7bf.svg";